import { Button, Modal } from "antd";
import lang from "../lang/lang.json";

const SubmitDefineCost = ({ open, setOpen, onOk }) => {
  return (
    <Modal onCancel={() => setOpen(false)} open={open} footer={null}>
      <div
        style={{
          width: 300,
          height: 180,
          padding: "25px 0",
          textAlign: "center",
          direction: "rtl",
          fontSize: 15,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>{lang.FEE_DECLARATION_CONFIRM_TITLE}</div>
        <div
          style={{
            width: "100%",
          }}
        >
          <Button
            style={{
              width: "45%",
              height: 40,
              borderRadius: 30,
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 1,
              borderColor: "rgb(210, 210, 210)",
              backgroundColor: "#1e5279",
              opacity: 1,
              color: "white",
              cursor: "pointer",
              marginLeft: 8,
            }}
            id="fee_declaration_final_submit_btn"
            onClick={onOk}
          >
            {lang.CONFIRM_AND_CONTINUE}
          </Button>
          <Button
            style={{
              width: "45%",
              height: 40,
              borderRadius: 30,
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 1,
              borderColor: "rgb(210, 210, 210)",
              backgroundColor: "white",
              opacity: 1,
              color: "#1e5279",
              cursor: "pointer",
            }}
            onClick={() => setOpen(false)}
          >
            {lang.CORRECTION}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default SubmitDefineCost;
